module.exports = __webpack_public_path__ + "static/media/point+18.ba2cd382.png";